import { Navigate, Route, Routes, useLocation, useRoutes } from "react-router-dom";

import { AppShell } from "./components/AppShell.js";
import { ErrorBoundary } from "./components/ErrorBoundary.js";
import { useAuth } from "./lib/auth-context.js";
import { LoginPage } from "./pages/LoginPage.js";
import { protectedRoutes } from "./routes.js";

function ProtectedRoutes() {
  const { user, loading } = useAuth();
  const location = useLocation();
  // A hook, so it runs before the early returns below can skip it.
  const routed = useRoutes(protectedRoutes);

  if (loading) {
    return (
      <div style={{ display: "flex", height: "100%", alignItems: "center", justifyContent: "center" }}>
        <span style={{ color: "var(--text-muted)" }}>Loading…</span>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  // An admin-issued password is known to someone other than its owner, so a
  // session holding one is only good for replacing it. The API enforces this
  // independently -- this redirect exists so the user meets an explanation
  // rather than a wall of 403s.
  if (user.mustChangePassword && location.pathname !== "/account/password") {
    return <Navigate to="/account/password" replace />;
  }

  return (
    <AppShell>
      {/* Backstop: the per-chart boundaries catch the likely failures, this
          catches anything else before it can blank the page. */}
      <ErrorBoundary label="PAGE">{routed}</ErrorBoundary>
    </AppShell>
  );
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/*" element={<ProtectedRoutes />} />
    </Routes>
  );
}
